/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var tab_containers = document.querySelectorAll('.tabs-container');
  if(tab_containers) {
    tab_containers.forEach((tab_container) => {
      var tab_container_list = tab_container.querySelector('ul'),
          tab_selector = tab_container.querySelector('.tabs-selector-container select');

      if(tab_selector) {
        tab_selector.addEventListener('change', (e) => {
          var open_tab = tab_container.querySelector('.tab-trigger.tab-current');

          if(tab_selector.value === '') {
            let open_tab_content = document.getElementById(open_tab.getAttribute('aria-controls'));

            open_tab.classList.remove('tab-current');
            open_tab.setAttribute('aria-expanded', 'false');
            open_tab_content.classList.remove('tab-current');
            return;
          }

          var target_tab = tab_container.querySelector('.tab-trigger[aria-controls="' + tab_selector.value + '"]');

          if(!target_tab.classList.contains('tab-trigger') || target_tab === open_tab) {
            return;
          }

          target_tab.click();
        });
      }

      tab_container_list.addEventListener('click', (e) => {
        e.preventDefault();

        var target_tab = e.target,
            open_tab = tab_container.querySelector('.tab-trigger.tab-current');

        if(!target_tab.classList.contains('tab-trigger') || target_tab === open_tab) {
          return;
        }

        var target_tab_content = document.getElementById(target_tab.getAttribute('aria-controls'));

        if(tab_selector) {
          tab_selector.value = target_tab.getAttribute('aria-controls');
        }

        const showTab = () => {
          if(open_tab) {
            let open_tab_content = document.getElementById(open_tab.getAttribute('aria-controls'));

            open_tab.classList.remove('tab-current');
            open_tab.setAttribute('aria-expanded', 'false');
            open_tab_content.classList.remove('tab-current');
          }

          target_tab.classList.add('tab-current');
          target_tab.setAttribute('aria-expanded', 'true');
          target_tab_content.classList.add('tab-current');
        };

        // Fallback for browsers that don't support View Transitions:
        if (!document.startViewTransition) {
          showTab();
        } else {
          document.startViewTransition(() => showTab());
        }

        setTimeout(function() {
          const tab_event = new CustomEvent('tab-opened', { detail: target_tab, bubbles: true });
          target_tab_content.dispatchEvent(tab_event);
        }, 100);
      });
    });
  }
}());